import { sqliteTable, text, integer, uniqueIndex } from "drizzle-orm/sqlite-core";
import { aiAgents } from "./ai-agents";
import { aiKnowledgeDocs } from "./ai-knowledge-docs";

// ============================================================================
// ai_agent_knowledge — Many-to-many: which docs each agent can use
// ============================================================================
export const aiAgentKnowledge = sqliteTable(
  "ai_agent_knowledge",
  {
    id: text("id").primaryKey(), // ULID
    agentId: text("agent_id")
      .notNull()
      .references(() => aiAgents.id),
    docId: text("doc_id")
      .notNull()
      .references(() => aiKnowledgeDocs.id),
    isEnabled: integer("is_enabled").default(1),
    // Audit fields
    createdAt: text("created_at").notNull(),
    createdBy: text("created_by"),
  },
  (table) => [
    uniqueIndex("idx_agent_knowledge_unique").on(table.agentId, table.docId),
  ]
);

export type AiAgentKnowledge = typeof aiAgentKnowledge.$inferSelect;
export type NewAiAgentKnowledge = typeof aiAgentKnowledge.$inferInsert;
